/* ================================================
   CANDy BLOOD - Craft Section Animations
   ================================================ */

function initCraftSection() {
  const craftSection = document.querySelector(".craft-section");
  if (!craftSection) return;

  // Header animations
  gsap.to(".craft-header h2", {
    opacity: 1,
    y: 0,
    duration: 1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".craft-header",
      start: "top 80%",
      toggleActions: "play none none reverse"
    }
  });

  gsap.to(".craft-header .subtitle", {
    opacity: 1,
    y: 0,
    duration: 1,
    delay: 0.2,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".craft-header",
      start: "top 80%",
      toggleActions: "play none none reverse"
    }
  });

  // Craft blocks animations
  const craftBlocks = gsap.utils.toArray(".craft-block");
  
  craftBlocks.forEach((block, index) => {
    const image = block.querySelector(".craft-image");
    const content = block.querySelector(".craft-content");
    const paragraphs = content.querySelectorAll("p");
    const heading = content.querySelector("h3");
    const isEven = index % 2 === 1;
    
    // Image animation
    gsap.to(image, {
      opacity: 1,
      x: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: block,
        start: "top 75%",
        toggleActions: "play none none reverse"
      }
    });

    // Heading animation
    gsap.to(heading, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: block,
        start: "top 75%",
        toggleActions: "play none none reverse"
      }
    });

    // Paragraphs gradually appear on scroll with scrub
    paragraphs.forEach((paragraph, pIndex) => {
      const startPercent = 80 - (pIndex * 10); // Each paragraph starts appearing progressively
      
      gsap.fromTo(paragraph, 
        {
          opacity: 0,
          y: 30
        },
        {
          opacity: 1,
          y: 0,
          ease: "power2.out",
          scrollTrigger: {
            trigger: block,
            start: `top ${startPercent}%`,
            end: `top ${startPercent - 20}%`,
            scrub: 1
          }
        }
      );
    });

    // Parallax effect on image
    gsap.to(image.querySelector("img"), {
      yPercent: -10,
      ease: "none",
      scrollTrigger: {
        trigger: block,
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
    });
  });

  // Process steps animation
  const processSteps = gsap.utils.toArray(".process-step");
  
  processSteps.forEach((step, index) => {
    gsap.to(step, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      delay: index * 0.15,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".craft-process",
        start: "top 80%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Horizontal scroll for process track (optional)
  const processTrack = document.querySelector(".process-track");
  if (processTrack) {
    const trackWidth = processTrack.scrollWidth;
    const containerWidth = document.querySelector(".craft-process")?.offsetWidth || window.innerWidth;
    
    if (trackWidth > containerWidth) {
      gsap.to(".process-track", {
        x: -(trackWidth - containerWidth + 100),
        ease: "none",
        scrollTrigger: {
          trigger: ".craft-process",
          start: "top center",
          end: `+=${trackWidth - containerWidth}`,
          scrub: 1,
          pin: true,
          anticipatePin: 1
        }
      });
    }
  }
}

// Export for main.js
window.initCraftSection = initCraftSection;
